import { useEffect, useState } from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Header from '../componets/Layout/Header';
import Sidebar from '../componets/Layout/Sidebar';
import MultipleSelected from '../componets/MultipleSelected';
import { UserValidateFields } from '../componets/validate/userValidation';
import { addEntryForm, getFormByCompany, getTemplateByCategories } from '../controller';
import { requestHandler } from '../helper';
import ErrorFilter from '../helper/errorFilter';
import SingleError from '../helper/SingleError';

function AddEntryFormManagement() {
  const requireField = ["companyName", "vendorSuite", "categoryId", "templateId"];
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    companyName: "",
    companyMotto: '',
    companyLogo: "",
    watermark: '',
    tag5: '',
    vendorSuit: '',
    categoryId: null,
    templateId: [],
  })
  const [companyData, setCompanyData] = useState([]);
  const [search, setSearch] = useState('');
  let { categoryData } = location.state || { categories: [], templates: [] }; // Fallback if no state is passed
  const [categoryId, setCategoryId] = useState("");

  const [tempData, setTempData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState([]);
  const [errors, setErrors] = useState({});
  const [submitCount, setSubmitCount] = useState(0);

  // Initialize pages with a default header
  const [pages, setPages] = useState([
    {
      id: Date.now(),
      header: [
        {
          headerLeft: '',
          headerCenter: '',
          headerRight: '',
          disclaimer: '',
          footerLeft: '',
          footerRight: ''
        }
      ]
    }
  ]);

  // Function to add a new page
  const handleAddPage = () => {
    setPages([...pages, {
      id: Date.now(),
      header: [
        {
          headerLeft: '',
          headerCenter: '',
          headerRight: '',
          disclaimer: '',
          footerLeft: '',
          footerRight: ''
        }
      ]
    }]);
  };

  // Function to delete a page
  const handleDeletePage = (id) => {
    setPages(pages.filter(page => page.id !== id)); // Remove the page by id
  };

  const handleHeaderChange = (pageIndex, headerIndex, field, value) => {
    const updatedPages = [...pages];
    updatedPages[pageIndex].header[headerIndex][field] = value; // Update the specific field of the header
    setPages(updatedPages);
  };

  const getTempData = async (categoryId) => {
    if (!categoryId) {
      // Handle case where categoryId is not set
      console.error("Category ID is required");
      return;
    }

    await requestHandler(
      async () => await getTemplateByCategories(categoryId),
      null,
      (res) => {
        setTempData(res.data.templates);
      },
      () => { }
    );
  };

  const handleChange = async (e) => {
    const { name, value, checked, type } = e.target;

    // Determine the new value based on input type
    const newValue = type === 'checkbox' ? checked : value;
    if (name === 'companyName') {
      setSearch(value); // Update search value when input changes
    }

    // Update the form data
    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));

    // Perform validation if necessary
    if (submitCount > 0) {
      let validationErrors = UserValidateFields({ ...formData, [name]: newValue });
      validationErrors = ErrorFilter(validationErrors, requireField);
      setErrors(validationErrors);
    }

  }

  const handleSubmit = async () => {
    setSubmitCount((prevCount) => prevCount + 1);
    let validationErrors = UserValidateFields(formData);
    validationErrors = ErrorFilter(validationErrors, requireField);
    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      // Prepare the request body
      const requestBody = {
        companyName: formData.companyName,
        companyMotto: formData.companyMotto,
        companyLogo: formData.companyLogo,
        watermark: formData.watermark,
        tag5: formData.tag5,
        vendorSuit: formData.vendorSuit,
        header: pages.flatMap(page => page.header),
        categoryId: categoryId,
        templateId: selectedTemplate.map(template => template._id),
      };

      await requestHandler(
        async () => await addEntryForm(requestBody),
        null,
        (res) => {
          toast.success(res.message);
          // Reset form data
          setFormData({
            companyName: "",
            companyMotto: '',
            companyLogo: "",
            watermark: '',
            tag5: '',
            vendorSuit: '',
            categoryId: null,
            templateId: [],
          });
          setPages([{
            id: Date.now(),
            header: [{
              headerLeft: '',
              headerCenter: '',
              headerRight: '',
              disclaimer: '',
              footerLeft: '',
              footerRight: ''
            }]
          }]); // Reset pages to initial state
          setTempData([]);
          navigate('/entry-form');
          setSubmitCount(0);
        },
        () => {
          setSubmitCount(0);
        }
      );
    }
  };



  const handleSelectTemplate = (template) => {
    setSelectedTemplate((prevSelectedTemplates) => {
      // Ensure prevSelectedTemplates is an array, defaulting to an empty array if undefined or null
      const updatedSelection = [...(prevSelectedTemplates || [])];

      const templateIndex = updatedSelection.findIndex(t => t._id === template._id);

      if (templateIndex > -1) {
        // If template is already selected, remove it
        updatedSelection.splice(templateIndex, 1);
      } else {
        // If template is not selected, add it
        updatedSelection.push(template);
      }

      return updatedSelection;
    });

    // Update formData templateId as an array of selected template IDs
    setFormData({
      ...formData,
      templateId: selectedTemplate.map(template => template._id), // Only store the IDs
    });
  };

  const getCompanyData = async () => {
    await requestHandler(
      async () => await getFormByCompany(search),
      null,
      (res) => {
        setCompanyData(res.data);
      },
      () => { }
    )
  }

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (search) {
        getCompanyData();
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [search]);

  useEffect(() => {
    if (companyData.length > 0) {
      // Prefill values when data is present
      setFormData({
        companyName: companyData[0].companyName || '',
        companyMotto: companyData[0].companyMotto || '',
        companyLogo: companyData[0].companyLogo || '',
        watermark: companyData[0].watermark || '',
        tag5: companyData[0].tag5 || '',
        vendorSuit: companyData[0].vendorSuit || '',

      });
      const updatedPages = companyData[0].header.map((headerItem, index) => ({
        id: Date.now() + index,  // Ensure unique IDs for each page
        header: [
          {
            headerLeft: headerItem.headerLeft || '',
            headerCenter: headerItem.headerCenter || '',
            headerRight: headerItem.headerRight || '',
            disclaimer: headerItem.disclaimer || '',
            footerLeft: headerItem.footerLeft || '',
            footerRight: headerItem.footerRight || ''
          }
        ]
      }));
      setPages(updatedPages);

    } else {
      setFormData({
        companyName: formData.companyName,
        companyMotto: formData.companyMotto,
        companyLogo: formData.companyLogo,
        watermark: formData.watermark,
        tag5: formData.tag5,
        vendorSuit: formData.vendorSuit,
        categoryId: categoryId,
        templateId: selectedTemplate.map(template => template._id),
        header: pages.flatMap(page => page.header),
      });
    }
  }, [companyData]);


  return (
    <>
      <div className='layouy-main'>
        <div className='sidebar-hide-show'>
          <Sidebar />
        </div>
        <div className='w-100'>
          <Header />
          <div className="tebs-title">
            <p className='active'>Entry Form Management</p>
          </div>
          <section className='px-20'>
            <div className="card border-bottom-0 rounded-bottom-0">
              <div className="card-header bg-transparent p-3">
                <div className='d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2'>
                  <h4 className='add-title'>Add Entry Form</h4>
                  <Link to='/entry-form' className='back-btn d-flex align-items-center gap-3 text-decoration-none'><img src="../images/png/left.png" width={8} alt="" /><p className='mb-0'>Back</p></Link>
                </div>
              </div>
              <div className="card-body px-20">
                <div className="card border-0">
                  <div className="card-body p-0">
                    <div className='modal-form pt-0'>
                      <Form className='row'>
                        <div className='col-12 col-md-12 col-xl-4'>
                          <Form.Group className="mb-3" controlId="formGroupEmail">
                            <Form.Label>Company Name*</Form.Label>

                            <Form.Control type="text" placeholder="Add Company Name" name='companyName'
                              value={formData.companyName}
                              onChange={handleChange} />
                          </Form.Group>
                          <SingleError error={errors?.companyName} />
                        </div>
                        <div className='col-12 col-md-12 col-xl-4'>
                          <Form.Group className="mb-3" controlId="formGroupEmail">
                            <Form.Label>Company Motto</Form.Label>
                            <Form.Control type="text" placeholder="Enter Company Motto" name='companyMotto' value={formData.companyMotto || ''} onChange={handleChange} />
                          </Form.Group>
                        </div>
                        <div className='col-12 col-md-12 col-xl-4'>
                          <Form.Group className="mb-3" controlId="formGroupEmail">
                            <Form.Label>Company Logo</Form.Label>
                            <Form.Control type="text" placeholder="Enter Company Logo" name='companyLogo' value={formData.companyLogo || ''} onChange={handleChange} />
                          </Form.Group>
                        </div>
                        <div className='col-12 col-md-12 col-xl-4'>
                          <Form.Group className="mb-3" controlId="formGroupEmail">
                            <Form.Label>WaterMark</Form.Label>
                            <Form.Control type="text" placeholder="Enter WaterMark" name='watermark' value={formData.watermark || ''} onChange={handleChange} />
                          </Form.Group>
                        </div>
                        <div className='col-12 col-md-12 col-xl-4'>
                          <Form.Group className="mb-3" controlId="formGroupEmail">
                            <Form.Label>Tag 5</Form.Label>
                            <Form.Control type="text" placeholder="Enter Tag 5" name='tag5' value={formData.tag5 || ''} onChange={handleChange} />
                          </Form.Group>
                        </div>
                        <div className='col-12 col-md-12 col-xl-4'>
                          <Form.Group className="mb-3" controlId="formGroupPassword">
                            <Form.Label>Vendor Suite*</Form.Label>
                            <Dropdown className='status-btn'>
                              <Dropdown.Toggle>
                                {formData.vendorSuit || 'Select Vendor Suite'}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                <Dropdown.Item onClick={() => setFormData({ ...formData, vendorSuit: 'Adobe' })}>Adobe</Dropdown.Item>
                                <Dropdown.Item onClick={() => setFormData({ ...formData, vendorSuit: 'Microsoft' })}>Microsoft</Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          </Form.Group>
                          <SingleError error={errors?.vendorSuit} />
                        </div>

                        <div className='col-12'>
                          <Form.Group className="mb-2" controlId="formGroupEmail">
                            <Form.Label>Pages</Form.Label>
                          </Form.Group>

                          {/* Loop over the pages array to render each card */}
                          {pages.map((page, pageIndex) => (
                            <div className="card mb-3" key={page.id}>
                              <div className="card-body">
                                <Form.Group className="mb-3" controlId={`formGroupPage${pageIndex}`}>
                                  <Form.Label>Page {pageIndex + 1}</Form.Label>
                                </Form.Group>
                                <div className="row">
                                  {page.header.map((header, headerIndex) => {
                                    return (
                                      <>
                                        <div className='col-12 col-md-12 col-xl-4'>
                                          <Form.Group className="mb-3" controlId={`formGroupHeaderLeft${headerIndex}`}>
                                            <Form.Label>Header Left</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Header Left" value={header.headerLeft}
                                              onChange={(e) => handleHeaderChange(pageIndex, headerIndex, 'headerLeft', e.target.value)} />
                                          </Form.Group>
                                        </div>
                                        <div className='col-12 col-md-12 col-xl-4'>
                                          <Form.Group className="mb-3" controlId={`formGroupHeaderCenter${headerIndex}`}>
                                            <Form.Label>Header Center</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Header Center" value={header.headerCenter}
                                              onChange={(e) => handleHeaderChange(pageIndex, headerIndex, 'headerCenter', e.target.value)} />
                                          </Form.Group>
                                        </div>
                                        <div className='col-12 col-md-12 col-xl-4'>
                                          <Form.Group className="mb-3" controlId={`formGroupHeaderRight${headerIndex}`}>
                                            <Form.Label>Header Right</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Header Right" value={header.headerRight}
                                              onChange={(e) => handleHeaderChange(pageIndex, headerIndex, 'headerRight', e.target.value)} />
                                          </Form.Group>
                                        </div>
                                        <div className='col-12 col-md-12 col-xl-4'>
                                          <Form.Group className="mb-3" controlId={`formGroupDisclaimer${headerIndex}`}>
                                            <Form.Label>Disclaimer</Form.Label>
                                            {/* <FloatingLabel controlId={`floatingTextarea${pageIndex}`} label="Enter Disclaimer" > */}
                                            <Form.Control
                                              as="textarea"
                                              placeholder="Enter Disclaimer"
                                              style={{ height: '100px' }}
                                              value={header.disclaimer}
                                              onChange={(e) => handleHeaderChange(pageIndex, headerIndex, 'disclaimer', e.target.value)}
                                            />
                                            {/* </FloatingLabel> */}
                                          </Form.Group>
                                        </div >
                                        <div className='col-12 col-md-12 col-xl-4'>
                                          <Form.Group className="mb-3" controlId={`formGroupFooterLeft${headerIndex}`}>
                                            <Form.Label>Footer Left</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Footer Left" value={header.footerLeft}
                                              onChange={(e) => handleHeaderChange(pageIndex, headerIndex, 'footerLeft', e.target.value)} />
                                          </Form.Group>
                                        </div>
                                        <div className='col-12 col-md-12 col-xl-4'>
                                          <Form.Group className="mb-3" controlId={`formGroupFooterRight${headerIndex}`}>
                                            <Form.Label>Footer Right</Form.Label>
                                            <Form.Control type="text" placeholder="Enter Footer Right" value={header.footerRight}
                                              onChange={(e) => handleHeaderChange(pageIndex, headerIndex, 'footerRight', e.target.value)} />
                                          </Form.Group>
                                        </div>
                                      </>
                                    )
                                  })}

                                </div>

                                <div className='d-flex justify-content-end'>
                                  {/* Delete Button */}
                                  {pages.length > 1 && (
                                    <button className='delete-link add-link bg-danger' onClick={() => handleDeletePage(page.id)}>
                                      <p className='m-0'>Delete Page</p>
                                    </button>
                                  )}
                                </div>

                              </div>
                            </div>
                          ))}

                          {/* Add Page Button */}
                          <div className='d-flex justify-content-end mt-3 mb-5'>
                            <div className='add-link' onClick={handleAddPage}>
                              <img src="../images/png/plush.png" width={12} height={12} alt="" />
                              <p className='m-0'>Add Pages</p>
                            </div>
                          </div>
                        </div>

                        <div className='col-12 col-md-12 col-xl-4'>
                          <Form.Group className="mb-3" controlId="formGroupPassword">
                            <Form.Label>Category*</Form.Label>
                            <Dropdown className='status-btn'>
                              <Dropdown.Toggle>
                                {selectedCategory || 'Select Category'}
                              </Dropdown.Toggle>
                              <Dropdown.Menu>
                                {categoryData.map((category, index) => (
                                  <Dropdown.Item
                                    key={index}
                                    onClick={() => {
                                      setCategoryId(category._id);
                                      setSelectedCategory(category.name);
                                      setSelectedTemplate([]);
                                      setFormData({
                                        ...formData,
                                        categoryId: category._id,
                                        templateId: []
                                      })
                                      delete errors.categoryId;
                                      setErrors({ ...errors });
                                      getTempData(category._id);
                                    }}
                                  >
                                    {category.name}
                                  </Dropdown.Item>
                                ))}
                              </Dropdown.Menu>
                            </Dropdown>
                          </Form.Group>
                          <SingleError error={errors?.categoryId} />
                        </div>
                        {/* <div className='col-12 col-md-12 col-xl-4'>
                            <Form.Group className="mb-3" controlId="formGroupPassword">
                              <Form.Label>Template*</Form.Label>
                              <Dropdown className='status-btn'>
                                <Dropdown.Toggle>
                                  {selectedTemplate || 'Select Template'}
                                </Dropdown.Toggle>
                                <Dropdown.Menu>
                                  {tempData.map((temp, index) => (
                                    <Dropdown.Item
                                      key={index}
                                      onClick={() => {
                                        setTemplateId(temp._id);
                                        setSelectedTemplate(temp.name);
                                        setFormData({
                                          ...formData,
                                          templateId: temp._id
                                        })
                                        delete errors.templateId;
                                        setErrors({ ...errors });
                                      }}
                                    >
                                      {temp.name}
                                    </Dropdown.Item>
                                  ))}
                                </Dropdown.Menu>
                              </Dropdown>
                            </Form.Group>
                            <SingleError error={errors?.templateId} />
                          </div> */}
                        <div className='col-12 col-md-12 col-xl-4'>
                          <MultipleSelected
                            label="Template"
                            options={tempData}
                            selectedStatus={selectedTemplate}
                            handleSelect={handleSelectTemplate}
                            index={0}
                            activeDropdowns={tempData?.length > 0}
                            error={errors?.templateId}
                          />
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
                <div className="row justify-content-end">
                  <div className="col-12 col-md-3 col-xl-2">
                    <div className='d-md-flex justify-content-end align-items-center gap-3 my-4'>
                      {/* <button className='cancel-btn' type='button'>Cancel</button> */}
                      <button className='save-btn' type='button' onClick={handleSubmit}>Submit</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div >
      </div>
    </>
  )
}

export default AddEntryFormManagement;